import { useTranslation } from "react-i18next";

import NewPage from "../../../layouts/page/NewPage";
import FormSection from "../../../components/Common/Form/FormSection";
import { successAlert } from "../../../components/alert/defaultAlert";
import EmployeeConsumptionForm from "../../../components/Custom/CashFlow/Consumption/EmployeeConsumptionForm";
import useEmployeeConsumptionForm from "../../../components/Custom/CashFlow/Consumption/useEmployeeConsumptionForm";
import MenuConfig from "../../../../constants/MenuConfig";

/**
 * Consumo da equipe > Novo, no padrão de página com rota do projeto.
 *
 * Usa os mesmos campos e o mesmo envio do modal da tela de Caixas. Não existe rota de edição:
 * consumo lançado errado é cancelado na listagem, nunca alterado.
 */
const EmployeeConsumptionNew = () => {

    const { t } = useTranslation();

    // Depois de salvar a página fica limpa para o próximo lançamento, como no cadastro de
    // vales: o gestor costuma registrar vários consumos de uma vez.
    const { formik, isBranchFixed } = useEmployeeConsumptionForm({
        onSaved: () => successAlert(t('message.operation_successfully'))
    });

    const onSubmit = (event) => {
        event.preventDefault();
        formik.handleSubmit();
    };

    return (
        <NewPage
            motherMenu={t('cash_flow.label')}
            childMenu={t('cash_flow.employee_consumptions')}
            activeMenu={t('new')}
            child={
                <div className="form-layout form-layout--spaced">
                    <FormSection
                        title={t('cash_flow.new_employee_consumption')}
                        description={t('cash_flow.consumption_information_hint')}
                        icon="fa-solid fa-mug-hot"
                    >
                        <EmployeeConsumptionForm formik={formik} isBranchFixed={isBranchFixed} />
                    </FormSection>
                </div>
            }
            isSubmitting={formik.isSubmitting}
            handleSubmit={onSubmit}
            cancelRoute={MenuConfig.cash_flow.employee_consumption.route}
        />
    );
};

export default EmployeeConsumptionNew;
